import styles from './index.module.css';
import { Select } from '@mantine/core';
import { useEffect, useState } from 'react';
import get from 'lodash/get';
import { getStrapiMedia } from '@utils/media';
import NextImage from '@components/elements/Image';
import Arrow from '@src/components/elements/Arrow';
import PdfViewer from '@components/elements/PdfViewer';
import { useRouter } from 'next/router';

export default function LegalDocuments({ pageData }) {
  const [url, setUrl] = useState(
    get(pageData, `versions[${pageData?.versions?.length - 1}].file.url`, '')
  );
  const [versionName, setVersionName] = useState(
    pageData?.versions?.[pageData?.versions?.length - 1]?.name
  );
  const [dropdownOneOpened, setDropdownOneOpened] = useState(false);
  const [stateEmbedded, setStateEmbedded] = useState(false);

  const router = useRouter();

  useEffect(() => {
    const queryKey = 'embedded';
    let embedded = false;
    try {
      embedded =
        router.query[queryKey] ||
        router.asPath.match(new RegExp(`[&?]${queryKey}=(.*?)(&|$)`))?.[1];
      embedded = embedded === 'true';
    } catch {
      embedded = false;
    }

    if (embedded !== stateEmbedded) {
      setStateEmbedded(embedded);
    }
  }, [router.query, router.asPath]);

  const handleVersionChange = (value) => {
    const index = pageData?.versions?.findIndex((version) => version.name === value);
    if (index !== -1) {
      setVersionName(value);
      setUrl(pageData?.versions[index].file.url);
    }
  };

  const pdfUrl = getStrapiMedia(url);

  useEffect(() => {
    const latestVersion = pageData?.versions?.[pageData?.versions?.length - 1];
    if (latestVersion) {
      setUrl(latestVersion.file.url);
      setVersionName(latestVersion.name);
    }
  }, [pageData]);


  if (stateEmbedded) {
    return (
      <div className={`relative ${styles.embedded}`}>
        <PdfViewer fileUrl={pdfUrl} />
      </div>
    );
  }

  return (
    <>
      <div className="relative bg-[#f5f5f5] pt-[10rem] pb-[4rem]">
        <div className="absolute top-0 h-full w-full ltr:left-0 rtl:right-0">
          <NextImage
            layout="fill"
            objectFit="cover"
            src="https://cdn.capex.com/uploads/featured_background_1d5d4beabb/featured_background_1d5d4beabb.png"
            priority
            alt="legal-docs-hero"
          />
        </div>
        <div className="relative z-10 container text-center">
          <NextImage
            src="https://cdn.capex.com/uploads/capex_com_logo_red2_0ee277e17c/capex_com_logo_red2_0ee277e17c.svg"
            width="540"
            height="169"
          />
          <h1 className="mb-0 pt-md text-dark">{pageData?.title || ''}</h1>
        </div>
      </div>

      {pageData?.versions?.length > 0 && (
        <div className="container pt-xl flex justify-center">
          <div className="w-full md:max-w-[40%] mx-auto">
            <Select
              className={styles['mantine-NativeSelect-wrapper']}
              data={pageData?.versions?.map((el) => el.name)}
              value={versionName}
              onChange={handleVersionChange}
              required
              onDropdownOpen={() => setDropdownOneOpened(true)}
              onDropdownClose={() => setDropdownOneOpened(false)}
              rightSection={
                <div className={dropdownOneOpened ? 'text-white' : 'text-secondary'}>
                  <Arrow direction="down" />
                </div>
              }
              classNames={{
                wrapper: styles.wrapper,
                input: dropdownOneOpened ? styles.selectInputOpened : styles.selectInputClosed,
                root: styles.selectRoot,
                rightSection: styles.rightSection,
                item: styles.itemSelect,
                dropdown: styles.dropdown,
              }}
            />
          </div>
        </div>
      )}

      <div className="container mt-xl pb-[8rem] relative">
        <PdfViewer fileUrl={pdfUrl} />
      </div>
    </>
  );
}
